export default __webpack_public_path__ + "static/media/employee-directory.1a92f0a9.png";